import { writable } from "svelte/store";
import { DashboardService } from "../../services/dashboard.service";
import { nvpToChart } from "../../utils/misc/chart-utils";
export const tiles = writable(null);
export const numSubmissionsByDate = writable(nvpToChart([]));
export const numTotalSubmissionsByClassroom = writable(nvpToChart([]));
export const numSuccessfulSubmissionsByClassroom = writable(nvpToChart([]));
export function loadDashboard() {
    loadTiles();
    loadNumSubmissionsByDate();
    loadNumSubmissionsByClassroom();
    loadNumSuccessfulSubmissionsByClassroom();
}
async function loadTiles() {
    let _resp = await DashboardService.getDashboardTiles();
    tiles.set(_resp.payload);
}
async function loadNumSubmissionsByDate() {
    let _resp = await DashboardService.getNumSubmissionsByDate();
    numSubmissionsByDate.set(nvpToChart(_resp.payload));
}
async function loadNumSubmissionsByClassroom() {
    let _resp = await DashboardService.getNumSubmissionsByClassroom();
    numTotalSubmissionsByClassroom.set(nvpToChart(_resp.payload));
}
async function loadNumSuccessfulSubmissionsByClassroom() {
    let _resp = await DashboardService.getNumSuccessfulSubmissionsByClassroom();
    numSuccessfulSubmissionsByClassroom.set(nvpToChart(_resp.payload));
}
